import { connect } from "react-redux";
import { closeCalculsFiltersSection, updateCalculsFilters } from "../actions";
import { CalculsFilters } from "../components/filters/CalculsFilters";
import {
  getAggregatedFamilyProducts,
  getFamilyProducts,
} from "../../family-product/actions";
import {
  loadAllUserFolders,
  updateFolderCalculsFilters,
} from "../../folders/actions/index";

export default connect(
  (state) => ({
    isFilterSectionOpen: state.calculs.isFilterSectionOpen,
    localConfigurator: state.configurator.localConfigurator,
    aggregatedFamilyProducts: state.familyProduct.aggregatedFamilyProducts,
    familyProducts: state.familyProduct.familyProducts,
    allFolders: state.folders.allFolders,
  }),
  (dispatch) => ({
    updateCalculsFilters: (filters) => {
      dispatch(updateCalculsFilters(filters));
    },
    updateFolderCalculsFilters: (filters) => {
      dispatch(updateFolderCalculsFilters(filters));
    },
    closeCalculsFiltersSection: () => {
      dispatch(closeCalculsFiltersSection());
    },
    getAggregatedFamilyProducts: () => {
      dispatch(getAggregatedFamilyProducts());
    },
    getFamilyProducts: () => {
      dispatch(getFamilyProducts());
    },
    loadAllUserFolders: () => {
      dispatch(loadAllUserFolders());
    },
  }),
)(CalculsFilters);
